/**
 * @generated SignedSource<<db1deed1d79f54eebfd22e6b7e2fe7f7>>
 * @relayHash dc6b7ad2efde2d6a0d217d7cfd97053d
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-nft/535.0.0-2025-11-04T15:40:23.188Z/NftProfileImportCollectionViewSubscription

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftProfileImportCollectionViewSubscription$variables = {
  fetchUser?: boolean | null;
  tokenContractId: string;
  userId: string;
};
export type NftProfileImportCollectionViewSubscription$data = {
  readonly nftTokenContractImportUpdate: {
    readonly nftTokenContractImport: {
      readonly " $fragmentSpreads": FragmentRefs<"NftProfileImportCollectionViewNftList_contractImport" | "NftProfileImportCollectionView_contractImport">;
    } | null;
  } | null;
};
export type NftProfileImportCollectionViewSubscription = {
  response: NftProfileImportCollectionViewSubscription$data;
  variables: NftProfileImportCollectionViewSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": true,
  "kind": "LocalArgument",
  "name": "fetchUser"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tokenContractId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v3 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "tokenContractId",
        "variableName": "tokenContractId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v4 = {
  "kind": "Literal",
  "name": "importStatuses",
  "value": [
    "NFT_ITEM_IMPORT_STATUS_COMPLETE",
    "NFT_ITEM_IMPORT_STATUS_PROCESSING",
    "NFT_ITEM_IMPORT_STATUS_ERROR"
  ]
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = [
  (v6/*: any*/),
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "contractAddress",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "kind": "Literal",
  "name": "first",
  "value": 0
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v13 = [
  (v12/*: any*/)
],
v14 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  },
  (v4/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v16 = [
  {
    "kind": "Literal",
    "name": "excludeCanceled",
    "value": true
  }
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v18 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "ether",
    "storageKey": null
  }
],
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "PublicProfile",
  "kind": "LinkedField",
  "name": "publicProfile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileName",
      "storageKey": null
    },
    (v7/*: any*/)
  ],
  "storageKey": null
},
v20 = [
  (v6/*: any*/),
  (v19/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "ensDomain",
    "storageKey": null
  },
  (v7/*: any*/)
],
v21 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rate",
    "storageKey": null
  }
],
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pdpUrl",
  "storageKey": null
},
v23 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "auctionId",
    "storageKey": null
  },
  (v17/*: any*/),
  (v9/*: any*/),
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NftProfileImportCollectionViewSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "NftTokenContractImportSubscriptionPayload",
        "kind": "LinkedField",
        "name": "nftTokenContractImportUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NftTokenContractImport",
            "kind": "LinkedField",
            "name": "nftTokenContractImport",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "NftProfileImportCollectionView_contractImport"
              },
              {
                "args": [
                  (v4/*: any*/)
                ],
                "kind": "FragmentSpread",
                "name": "NftProfileImportCollectionViewNftList_contractImport"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscriptions",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "NftProfileImportCollectionViewSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "NftTokenContractImportSubscriptionPayload",
        "kind": "LinkedField",
        "name": "nftTokenContractImportUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NftTokenContractImport",
            "kind": "LinkedField",
            "name": "nftTokenContractImport",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "importStatus",
                "storageKey": null
              },
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "collectionName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "collectionDescription",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NftTokenContract",
                "kind": "LinkedField",
                "name": "contract",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tokenStandard",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  (v10/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "symbol",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "processingItems",
                "args": [
                  (v11/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "importStatuses",
                    "value": [
                      "NFT_ITEM_IMPORT_STATUS_PROCESSING"
                    ]
                  }
                ],
                "concreteType": "NftTokenContractImportCreatedItemsConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": (v13/*: any*/),
                "storageKey": "items(first:0,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_PROCESSING\"])"
              },
              {
                "alias": "completeItems",
                "args": [
                  (v11/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "importStatuses",
                    "value": [
                      "NFT_ITEM_IMPORT_STATUS_COMPLETE"
                    ]
                  }
                ],
                "concreteType": "NftTokenContractImportCreatedItemsConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": (v13/*: any*/),
                "storageKey": "items(first:0,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_COMPLETE\"])"
              },
              {
                "alias": "failedItems",
                "args": [
                  (v11/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "importStatuses",
                    "value": [
                      "NFT_ITEM_IMPORT_STATUS_ERROR"
                    ]
                  }
                ],
                "concreteType": "NftTokenContractImportCreatedItemsConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": (v13/*: any*/),
                "storageKey": "items(first:0,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_ERROR\"])"
              },
              {
                "alias": "description",
                "args": null,
                "kind": "ScalarField",
                "name": "collectionDescription",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v14/*: any*/),
                "concreteType": "NftTokenContractImportCreatedItemsConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftTokenContractImportCreatedItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NftItem",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "importErrorReason",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "NftDigitalArtMetadataMedia",
                                    "kind": "LinkedField",
                                    "name": "media",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "mimeType",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "webUrl",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "posterFrameUrl",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "videoThumb",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "edition",
                                    "storageKey": null
                                  }
                                ],
                                "type": "NftDigitalArtMetadata",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v16/*: any*/),
                            "concreteType": "NftAuction",
                            "kind": "LinkedField",
                            "name": "mostRecentAuction",
                            "plural": false,
                            "selections": [
                              (v17/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EtherAmount",
                                "kind": "LinkedField",
                                "name": "currentBid",
                                "plural": false,
                                "selections": (v18/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EtherAmount",
                                "kind": "LinkedField",
                                "name": "reservePrice",
                                "plural": false,
                                "selections": (v18/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "winnerAddress",
                                "plural": false,
                                "selections": (v20/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NftItem",
                                "kind": "LinkedField",
                                "name": "item",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EtherRates",
                                    "kind": "LinkedField",
                                    "name": "etherRates",
                                    "plural": true,
                                    "selections": (v21/*: any*/),
                                    "storageKey": null
                                  },
                                  (v7/*: any*/),
                                  (v22/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NftConversionRateEvent",
                                "kind": "LinkedField",
                                "name": "endedConversionRates",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EtherRates",
                                    "kind": "LinkedField",
                                    "name": "rates",
                                    "plural": true,
                                    "selections": (v21/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "creatorAddress",
                                "plural": false,
                                "selections": (v8/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "sellerAddress",
                                "plural": false,
                                "selections": (v8/*: any*/),
                                "storageKey": null
                              },
                              (v7/*: any*/)
                            ],
                            "storageKey": "mostRecentAuction(excludeCanceled:true)"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "wasBurned",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LinkData",
                            "kind": "LinkedField",
                            "name": "linkData",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "path",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isLinkable",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NftItemLikes",
                            "kind": "LinkedField",
                            "name": "likes",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "likeCount",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EthereumAddressType",
                            "kind": "LinkedField",
                            "name": "creatorAddress",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "publicProfileUrl",
                                "storageKey": null
                              },
                              (v19/*: any*/),
                              (v7/*: any*/),
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalSupply",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isERC1155",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EthereumAddressType",
                            "kind": "LinkedField",
                            "name": "ownerAddress",
                            "plural": false,
                            "selections": (v20/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tokenId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tokenUri",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NftTokenContract",
                            "kind": "LinkedField",
                            "name": "contract",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "addressWithFields",
                                "plural": false,
                                "selections": (v8/*: any*/),
                                "storageKey": null
                              },
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "condition": "fetchUser",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Variable",
                                    "name": "userId",
                                    "variableName": "userId"
                                  }
                                ],
                                "concreteType": "NftItemBalance",
                                "kind": "LinkedField",
                                "name": "balanceForUser",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "balance",
                                    "storageKey": null
                                  },
                                  (v7/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EthereumAddressType",
                                    "kind": "LinkedField",
                                    "name": "ownerAddress",
                                    "plural": false,
                                    "selections": (v8/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "alias": "recentAuction",
                            "args": (v16/*: any*/),
                            "concreteType": "NftAuction",
                            "kind": "LinkedField",
                            "name": "mostRecentAuction",
                            "plural": false,
                            "selections": (v23/*: any*/),
                            "storageKey": "mostRecentAuction(excludeCanceled:true)"
                          },
                          (v22/*: any*/),
                          {
                            "alias": "auction",
                            "args": (v16/*: any*/),
                            "concreteType": "NftAuction",
                            "kind": "LinkedField",
                            "name": "mostRecentAuction",
                            "plural": false,
                            "selections": (v23/*: any*/),
                            "storageKey": "mostRecentAuction(excludeCanceled:true)"
                          },
                          (v15/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:20,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_COMPLETE\",\"NFT_ITEM_IMPORT_STATUS_PROCESSING\",\"NFT_ITEM_IMPORT_STATUS_ERROR\"])"
              },
              {
                "alias": null,
                "args": (v14/*: any*/),
                "filters": [
                  "importStatuses"
                ],
                "handle": "connection",
                "key": "NftProfileImportCollectionViewNftList_items",
                "kind": "LinkedHandle",
                "name": "items"
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-nft/535.0.0-2025-11-04T15:40:23.188Z/NftProfileImportCollectionViewSubscription",
    "metadata": {},
    "name": "NftProfileImportCollectionViewSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "746bceb95632d82f3a721f204cf56319";

export default node;
